import { cloneDeep } from 'lodash';

export default function getWallPoints(oldPoints, width, height) {
  const points = cloneDeep(oldPoints);
  const rightPointsIndex = [0, 1];
  const topPointsIndex = [0, 1];
  for (let i = 2; i < points.length; i++) {
    if (points[i].x > points[rightPointsIndex[0]].x) {
      rightPointsIndex[0] = i;
    } else if (points[i].x > points[rightPointsIndex[1]].x) {
      rightPointsIndex[1] = i;
    }

    if (points[i].y > points[topPointsIndex[0]].y) {
      topPointsIndex[0] = i;
    } else if (points[i].y > points[topPointsIndex[1]].y) {
      topPointsIndex[1] = i;
    }
  }

  if (width) {
    points[rightPointsIndex[0]].x = parseFloat(width);
    points[rightPointsIndex[1]].x = parseFloat(width);
  }

  if (height) {
    points[topPointsIndex[0]].y = parseFloat(height);
    points[topPointsIndex[1]].y = parseFloat(height);
  }

  return points;
}
